import React from "react";
import { formatDate } from "../../../../../../functions/dateTime/formatDate";
import dialogIcon from "../../../../../../assets/icons/dialog icon.svg";

const ReceivedHistoryView = ({ item, type, onDialogClick }) => {
  const handleClick = () => {
    onDialogClick(item, type);
  };
  return (
    <div className="pl-4 pt-4 relative">
      <p className="cy-history-green-dot"></p>
      <p className="cy-history-green-line"></p>
      <div className="cy-history-box-gray">
        <div className="cy-history-state-head">
          <p className="cy-history-received">Received</p>
          <p>{formatDate(item.updatedAt)}</p>
        </div>
        <div className="cy-history-flexEnd">
          <div>
            <p className="cy-history-showStation">
              {item.receivedAtStation.name}{" "}
              <span className="text-xs">({item.receivedAtStation.id})</span>
            </p>
            <p className="text-sm">(Received By: {item.updatedBy.fullName})</p>
          </div>
          <button className="cy-history-viewBtn" onClick={handleClick}>
            <img src={dialogIcon} alt="view" className="mr-1" />
            View
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ReceivedHistoryView);
